<template>
    <div class="header-apr">
        <HeadDetailsGama :titleHead="'Detalhes da APR'" :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';"></HeadDetailsGama>
        <Tables ref="tableSignatureApr"
            :columns="colunas"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :newHeaderStatus="true"
            :showHeader="false"
            v-on:Load="onLoad"
            style="font-family: 'Segoe UI';">
            <tr v-for="(obj,index) in dataSignature" :key="index">
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.nomeFuncionario !== null ? obj.nomeFuncionario : obj.nomeAssinatura"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.tipoExecutanteDescricao"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.dataAssinaturaFormatadaDia"></TableColumn>
                <TableColumn :IsDocumentActions="true"
                    :HasDownload="false"
                    :HasDetails="hasRole(roles.RW_REAL_ESTA_ADMIN)  || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) ? true : false"
                    :HasDocumentDelete="false"
                    style="justify-content: center ;display: flex;"
                    v-on:Details="openPopUpSignature(obj.assinaturaID)"
                ></TableColumn>
            </tr>
        </Tables>
        <b-modal ref="assinatura-render"
            size="lg"
            centered
            id="assinatura-renderId"
            title="Visualizar Assinatura"
            :hide-footer="true"
            :clickToClose="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            hide-header-close
            >
            <template #modal-title="{ close }">
                  <div class="header w-100">
                    <div class="titulo-modal">Visualizar Assinatura</div>
                    <div class="button-modal d-flex">
                      <div class="ml-3 mr-3 closepoup" @click="close()"><i class="fa fa-times"></i></div>
                    </div>
                  </div>
                </template>
              <div class="infoSingature p-3">
                <!--Removemos as validações para edição dos dados associados às assinaturas, pois, quando o sistema está offline, a impossibilidade de edição causa grandes problemas. -->
                <div  class="edit-save">
                  <div @click="clickEdit" class="mb-3 btn-edit" style="cursor: pointer;">
                    <i class="fas fa-edit ml-3 mr-2" style="cursor: pointer;" v-b-tooltip.hover title="Editar Informações">
                    </i>
                    Editar
                  </div>
                  <div class="btn-header">
                    <div class="btn-appr-rep mr-3">
                      <button :class="isEdit === true ? 'btn-appr-popup' : 'btn-appr-popup-disabled'" @click="verificaCamposEdit"><i class="fas fa-save mr-2"></i>SALVAR</button>
                    </div>
                  </div>
                </div>
              <div class="d-flex">
                <div class="docSignature w-50 ml-3 mr-3">
                  <div class="font-title"> {{ detalhes.externo === false ? "Matrícula" : "Documento"}}</div>
                  <div class="d-flex align-items-center">
                    <autocomplete-z
                      v-if="isEdit == true && !IsExterno"
                      ref="responsavelTypeahead"
                      placeholder="Informe a matricula do funcionário"
                      type="text"
                      :serializer="(responsavel) => responsavel.code"
                      :formField="form.ResponsavelId"
                      v-on:changeCode="onChangeCodeResponsavel"
                      :ShowInput="false"
                      @change="getInput"
                      />

                    <div v-if="detalhes.documento !== null" class="font-title mr-2"> {{ detalhes.documento == 1 ? "CPF" : "RG"}}</div>
                    <b-input
                    v-if="!IsExterno && isEdit == false"
                    :disabled="true"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto'"
                    v-model="detalhes.matricula"></b-input>
                    <b-input
                     v-if="IsExterno && isEdit == false"
                    :disabled="true"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto'"
                    :maxlength="detalhes.documento == 1 ? 11 : 9 "
                    v-model="detalhes.documentoAssinatura"></b-input>
                  </div>
                </div>
                <div class="nameSignature w-50 ml-3 mr-3">
                  <div class="font-title">Nome Funcionário</div>
                  <autocomplete-z
                      v-if="isEdit === true && IsExterno === false"
                      ref="responsavelTypeahead"
                      placeholder="Informe o nome do funcionário"
                      type="text"
                      :serializer="(responsavel) => responsavel.nome"
                      :formField="form.ResponsavelId"
                      v-on:search="onSearchResponsavel"
                      :ShowCode="false"
                      />
                  <b-input
                    v-else-if="isEdit == true && !IsExterno"
                    :disabled="true"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto;'"
                    v-model="detalhes.nomeFuncionario"></b-input>
                  <b-input
                    v-else
                    :disabled="isEdit === false && IsExterno"
                    :style="isEdit === false ? 'cursor: not-allowed; background-color: #ebebeb; color: grey' : 'cursor: auto;'"
                    v-model="detalhes.nomeAssinatura"></b-input>
                </div>
              </div>
            </div>
            <div class="comprovante-container">
              <object class="img-container" >
                <div class="d-flex flex-column">
                    <img
                    class="signature-overview"
                    :src="`${`data:image/${type}`};base64,`+ midiapdf">
                </div>
                </object>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import { loading, toast } from '@/shared/utils/UIHelper'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'

export default {
  name: 'registerTable',
  mixins: [ActionsForm, ExpenseMixin],
  components: {HeadDetailsGama, AutocompleteZ},
  data () {
    return {
      colunas: ['NOME', 'CARGO', 'DATA ASSINATURA', ''],
      dataSignature: [],
      formSearch: {},
      columTemplate: ['Atividades'],
      type: 'jpeg',
      midiapdf: null,
      index: null,
      detalhes: {},
      originalDetails: {},
      form: {
        ResponsavelId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      isEdit: false,
      IsExterno: false
    }
  },

  props: ['propApr'],

  watch: {
    'form.ResponsavelId.code' (newValue) {
      if (this.form.ResponsavelId.code !== null) {
        this.detalhes.matricula = newValue
      }
    },
    'form.ResponsavelId.value' (newValue) {
      if (this.form.ResponsavelId.value !== null) {
        this.detalhes.funcionarioId = newValue
      }
    }
  },

  mounted () {
    this.onLoad()
  },
  methods: {
    onSelect (collabId) {
      this.$router.push(`/APR/Consulta/Detalhes/`)
    },
    onLoad () {
      loading.push()
      AprAnalisePreliminarRisco.GetAllExecutorsApr(this.propApr.id, this.$refs.tableSignatureApr.pagingLimit, this.$refs.tableSignatureApr.pagingIndex)
        .then(Response => {
          this.$refs.tableSignatureApr.LoadAllByData(Response)
          this.dataSignature = Response.data.data
          this.$emit('dataSignature', this.dataSignature)
          loading.pop()
        })
        .catch(err => {
          console.log(err)
          loading.pop()
        })
    },
    openPopUpSignature (value) {
      this.isEdit = false
      this.posicao = this.dataSignature.findIndex(item => item.assinaturaID === value)
      this.detalhes = this.dataSignature[this.posicao]
      if (this.originalDetails === null) {
        this.originalDetails = { ...this.detalhes }
      }
      this.verificaEdicao()

      this.getSignature(value)
      this.$refs['assinatura-render'].show()
    },
    cancel () {
      // this.midipdf = null
      this.$refs['assinatura-render'].hide()
    },
    getSignature (obj) {
      this.midiapdf = null
      this.type = 'jpeg'
      // Executante sem assinatura (regra APR-022, opcional) manda assinaturaID vazio.
      if (!obj || obj === '00000000-0000-0000-0000-000000000000') {
        toast.warning('Este executante não possui assinatura.')
        return
      }
      loading.push()
      AprAnalisePreliminarRisco.getSignatureApr(obj)
        .then(Response => {
          const item = Response.data.data && Response.data.data[0]
          if (item && item.img64) {
            this.midiapdf = item.img64
          } else {
            toast.warning('Assinatura não encontrada.')
          }
          loading.pop()
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    clickEdit () {
      this.isEdit = !this.isEdit
    },
    saveEdit () {
      this.detalhesEditado = {...this.detalhes}
      const ExecutanteEdit = {
        ID: this.detalhesEditado.id,
        DataAssinatura: this.detalhesEditado.DataAssinatura,
        DataAssinaturaFormatada: this.detalhesEditado.DataAssinaturaFormatada,
        DataAssinaturaFormatadaDia: this.detalhesEditado.DataAssinaturaFormatadaDia,
        TipoExecutante: this.detalhesEditado.tipoExecutante,
        TipoExecutanteDescricao: this.detalhesEditado.tipoExecutanteDescricao,
        NomeFuncionario: this.detalhesEditado.nomeFuncionario !== null ? this.detalhesEditado.nomeFuncionario : this.detalhesEditado.nomeAssinatura,
        funcionarioId: this.detalhes.externo === false && this.propApr.offline === false ? this.form.ResponsavelId.value : this.detalhesEditado.funcionarioId,
        AssinaturaID: this.detalhesEditado.AssinaturaID,
        AssinaturaStatus: this.detalhesEditado.AssinaturaStatus,
        AssinaturaStatusDescricao: this.detalhesEditado.AssinaturaStatusDescricao,
        NomeAssinatura: this.detalhesEditado.nomeAssinatura,
        Documento: this.detalhesEditado.documento,
        DocumentoAssinatura: this.detalhesEditado.documentoAssinatura,
        externo: this.detalhesEditado.externo,
        matricula: this.detalhesEditado.matricula,
        obraid: this.propApr.obraid,
        AprID: this.propApr.id
      }
      loading.push()
      AprAnalisePreliminarRisco.EditInfoAssinaturaApr(ExecutanteEdit)
        .then(Response => {
          loading.pop()
          toast.success('Informações editadas com êxito!')
          this.$refs['assinatura-render'].hide()
          this.onLoad()
          this.isEdit = !this.isEdit
        })
        .catch(err => {
          console.log(err)
          loading.pop()
          toast.warning('Erro ao alterar informações do funcionário!')
        })
    },
    close () {
      this.isEdit = !this.isEdit
      this.detalhes = this.originalDetails
      this.$refs['assinatura-render'].hide()
    },
    verificaEdicao () {
      this.IsExterno = false
      if (this.detalhes.externo === true) {
        this.IsExterno = true
      } else {
        this.IsExterno = false
      }
    },
    verificaCamposEdit () {
      if (this.IsExterno === false) {
        if (this.form.ResponsavelId.value == null) {
          toast.warning('Campos não podem ser nulos!')
        } else {
          this.saveEdit()
        }
      }
      if (this.IsExterno === true) {
        if (this.detalhes.nomeAssinatura === null ||
          this.detalhes.nomeAssinatura === '' ||
          this.detalhes.documentoAssinatura == null ||
          this.detalhes.documentoAssinatura === '') {
          toast.warning('Campos não podem ser nulos!')
        } else {
          this.saveEdit()
        }
      }
      // if (this.isExtOn) {
      //   if (this.detalhes.nomeFuncionario === null ||
      //   this.detalhes.nomeFuncionario === '' ||
      //   this.detalhes.documentoAssinatura == null ||
      //   this.detalhes.documentoAssinatura === '') {
      //     toast.warning('Campos não podem ser nulos!')
      //   } else {
      //     this.saveEdit()
      //   }
      // }
    }
  }
}

</script>

<style scoped>
.signature-overview{
  max-height: 35rem;
}
.edit-save {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.font-title, .font-info{
  font-size: 14px;
}
.font-title{
  font-weight: bold;
  color:#008144;
}

.nameSignature, .docSignature{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: 'Segoe UI';
  font-size: 14px;
}

.infoSingature {
  background-color: #f3f1f1;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 1rem;
}
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price{
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
}
.header-title{
color: white;
font-weight: bold;
font-size: 16px;
font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.button-cancel,
.button-save{
margin-top: 10;
font-size: 12PX;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}
.button-save{
background-color: darkgreen;
color: white;
}
.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }

  .header {
    display: flex;
    flex-wrap: wrap;
    color: white;
    justify-content: space-between;
    align-items: center;
    width:100%;
  }

  .button-modal {
  position: absolute;
    align-items: center;
    right: 0px;
}

.btn-header {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  .btn-repappr{
    gap: 1rem;
  }
  .btn-appr-rep {
  display: flex;
  justify-content: space-around;
  font-family: 'Segoe UI';
}
.btn-rep-popup{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 2rem;
    font-size: 14px;
  }
.btn-appr-popup{
    width: 10vw;
    height: 2rem;
    background: #008144;;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size:14px
}

.btn-appr-popup-disabled{
    width: 10vw;
    height: 2rem;
    background-color: #D8D8D8;;
    color: #636363;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size:14px
}
.btn-edit{
  color: #008144;
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 14px;
  display: flex;
  align-items: center;
  width: 15%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/signatures/signatures.vue